import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ChevronRight, ChevronLeft, Bell } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

const TITLES = {
  '/':            { ar: 'الرئيسية',     en: 'Home' },
  '/specialties': { ar: 'التخصصات',    en: 'Specialties' },
  '/doctors':     { ar: 'الأطباء',      en: 'Doctors' },
  '/appointments':{ ar: 'مواعيدي',     en: 'My Appointments' },
  '/records':     { ar: 'ملفي الطبي',   en: 'My Records' },
  '/followup':    { ar: 'متابعة العلاج', en: 'Follow-up' },
  '/vitals':      { ar: 'العلامات الحيوية', en: 'Vital Signs' },
  '/chat':        { ar: 'المحادثات',    en: 'Messages' },
  '/profile':     { ar: 'حسابي',        en: 'My Account' },
};

export default function TopBar() {
  const { t, i18n } = useTranslation();
  const navigate  = useNavigate();
  const location  = useLocation();
  const { user }  = useAuth();
  const isAr      = i18n.language === 'ar';
  const isHome    = location.pathname === '/';

  const titleObj = Object.entries(TITLES).find(([k]) => location.pathname === k || location.pathname.startsWith(k + '/'));
  const title    = titleObj ? titleObj[1][isAr ? 'ar' : 'en'] : '';
  const BackIcon = isAr ? ChevronLeft : ChevronRight;

  return (
    <header className="fixed top-0 inset-x-0 z-40 bg-white border-b border-gray-100 pt-safe">
      <div className="flex items-center justify-between px-4 h-14">
        <div className="flex items-center gap-3">
          {!isHome && (
            <button onClick={() => navigate(-1)} className="p-2 -ms-2 rounded-full hover:bg-gray-100 transition-colors">
              <BackIcon size={20} className="text-gray-600" />
            </button>
          )}
          {isHome ? (
            <div className="flex flex-col">
              <span className="text-xs text-gray-500">{isAr ? 'أهلاً،' : 'Hello,'}</span>
              <span className="text-sm font-bold text-gray-900 leading-tight">{user?.fullNameAr || 'مريض'}</span>
            </div>
          ) : (
            <h1 className="text-base font-bold text-gray-900">{title}</h1>
          )}
        </div>

        <div className="flex items-center gap-2">
          <button
            onClick={() => { const next = isAr ? 'en' : 'ar'; i18n.changeLanguage(next); }}
            className="px-2 py-1 text-xs font-bold text-blue-600 bg-blue-50 rounded-lg hover:bg-blue-100 transition-colors"
          >
            {isAr ? 'EN' : 'ع'}
          </button>
          <button onClick={() => navigate('/notifications')} className="relative p-2 rounded-full hover:bg-gray-100">
            <Bell size={20} className="text-gray-600" />
          </button>
        </div>
      </div>
    </header>
  );
}
